import React, { useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import style from './GraphUi.module.css'
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
    Legend,
    DotProps,
    BarChart,
    Bar,
    Brush,
} from 'recharts'
import {
    deviceReadIndex,
    graphSidebarData,
    sensorsData,
} from '../GraphsensorsPortData'
import {
    generateDeviceDataKey,
    humanoidPABytesToSensorData,
    MSBLSBToDecimal,
    playComputerPABytesToSensorData,
    robokiPABytesToSensorData,
} from '../../../ReusableComponents/ByteTransfer/utils'

import * as XLSX from 'xlsx'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import html2canvas from 'html2canvas'
// let totalTime = 0
let dataQues = []
// const data = [
//     { name: 'A', line1: 10, line2: 20 },
//     { name: 'B', line1: 30, line2: 40 },
//     { name: 'C', line1: 50, line2: 35 },
//     { name: 'D', line1: 40, line2: 45 },
//     { name: 'E', line1: 70, line2: 55 },
// ]

// const lineKeys = ['line1', 'line2']

const calculateSlope = (p1, p2) => {
    const x1 = p1.index
    const x2 = p2.index
    const y1 = p1.value
    const y2 = p2.value
    return x2 !== x1 ? ((y2 - y1) / (x2 - x1)).toFixed(2) : '∞'
}
// const defaultDatas = {
//     pv: '',
//     uv: 0,
//     mic: 0,
//     temp: 0,
//     batt: 0,
//     touch0: 0,
//     touch2: 0,
//     touch3: 0,
//     acceX: 0,
//     acceY: 0,
//     acceZ: 0,
//     gyroX: 0,
//     gyroY: 0,
//     gyroZ: 0,
//     ultrasonic: 0,
//     red: 0,
//     green: 0,
//     blue: 0,
//     // distance: 0,
//     proximity: 0,
//     light: 0,
//     gesture: 0,
//     switch1: 0,
//     switch2: 0,
//     A1: 0,
//     A2: 0,
//     B1: 0,
//     B2: 0,
//     C1: 0,
//     C2: 0,
//     D1: 0,
//     D2: 0,
//     E1: 0,
//     E2: 0,
//     F1: 0,
//     F2: 0,
// }
function GraphGeneration({
    datasRef,
    setDatasRef,
    stopFuntionRef = () => {},
    worker,
    graphType,
    portsData,
    graphPlotStorage,
    // isSelectInternalAccessories,
    // reduxInternalaccessories,
    time,
    setSlopeInfo,
    slopeInfo,
    graphRunInfo,
    selectedRunGraph,
    addPlotData,
    selectedTemperatureScale,
    // chartRef,
}) {
    const chartRef = useRef(null)
    const totalTimeRef = useRef(0)
    const [datas, setDatas] = useState([])
    const connectedDevice = sessionStorage.getItem('connectedDevice')
    const deviceVersion = sessionStorage.getItem('deviceVersion')
    // const [selectedPoints, setSelectedPoints] = useState([])

    //set the graph data on change the footer run change
    const setDatasState = ({ type, plotData = [], totalTime }) => {
        if (type === 'reset') {
            setDatas([])
            totalTimeRef.current = totalTime
        }
        if (type === 'setReduxDatas') {
            addPlotData({ totalTime: totalTimeRef.current, plotData: datas })
        }
        if (type === 'set') {
            setDatas(plotData)
        }
    }

    useEffect(() => {
        setDatasRef.current = setDatasState
    }, [setDatasRef, setDatasState])
    // useEffect(() => {}, [graphRunInfo,selectedRunGraph])

    const handleDotClick = (payload, index, lineKey) => {
        const point = {
            index,
            lineKey,
            value: payload[lineKey],
            pv: payload['pv'],
        }

        if (
            slopeInfo.selectedPoints.length >= 2 ||
            (slopeInfo.selectedPoints.length === 1 &&
                slopeInfo.selectedPoints[0].lineKey !== point.lineKey)
        ) {
            let selectedPoints = [point]
            setSlopeInfo({
                selectedPoints,
                message: `first point selected :(${selectedPoints[0].value}, ${selectedPoints[0].pv})`,
            })
        } else {
            const selectedPoints = [...slopeInfo.selectedPoints, point]
            let slope = ''
            let message = ''
            if (selectedPoints.length === 2) {
                slope = calculateSlope(selectedPoints[0], selectedPoints[1])
                message = `Slope between points (${selectedPoints[0].value}, ${selectedPoints[0].pv}) and (${selectedPoints[1].value}, ${selectedPoints[1].pv}) is ${slope}`
            } else {
                message = `first point selected :(${selectedPoints[0].value}, ${selectedPoints[0].pv})`
            }

            setSlopeInfo({
                selectedPoints,
                slope,
                message,
            })
        }
    }

    //geve the red color dot what ever point are selected
    const isPointSelected = (index, lineKey) =>
        slopeInfo.selectedPoints.some(
            (p) => p.index === index && p.lineKey === lineKey
        )

    function calculateTemperature(adcRaw) {
        // Constants
        const R25 = 1000.0 // Resistance at 25°C in Ohms
        const Rref = 1000.0 // Reference resistor value in Ohms
        const beta = 3950.0 // Beta coefficient of the thermistor
        const T25 = 298.15 // 25°C in Kelvin

        // Calculate thermistor resistance using the ADC raw value
        const Rntc = (Rref * adcRaw) / (4096 - adcRaw)

        // Calculate temperature in Kelvin using the Beta formula
        let KelvinData = beta / (Math.log(Rntc / R25) + beta / T25)

        if (selectedTemperatureScale === 'C') {
            return Math.round(KelvinData - 273.15)
        }
        if (selectedTemperatureScale === 'F') {
            return Math.round(((KelvinData - 273.15) * 9) / 5 + 32)
        }
        return Math.round(KelvinData)
    }

    //read bytes push in to the graph
    const recievedBytes_v = (bytesRecieved) => {
        try {
            let PORTDATAKey = generateDeviceDataKey(
                connectedDevice,
                deviceVersion
            )
            const readIndex = deviceReadIndex[PORTDATAKey]

            if (bytesRecieved === undefined) return
            let sensorData = {}

            totalTimeRef.current =
                Math.floor(
                    (totalTimeRef.current +
                        time.ms / 1000 +
                        time.s +
                        time.m * 60 +
                        time.h * 60 * 60) *
                        100
                ) / 100
            Object.keys(readIndex).map((key) => {
                if (connectedDevice === 'Ace') {
                    if (
                        graphRunInfo[selectedRunGraph].selectedSensors.includes(
                            key
                        )
                    ) {
                        let rawData = playComputerPABytesToSensorData(
                            bytesRecieved.slice(2),
                            readIndex[key].index
                        )
                        if (key === 'temp') {
                            rawData = calculateTemperature(rawData)
                        }
                        if (key === 'red') {
                            sensorData[key] = rawData[0]
                        } else if (key === 'green') {
                            sensorData[key] = rawData[1]
                        } else if (key === 'blue') {
                            sensorData[key] = rawData[2]
                        } else {
                            sensorData[key] = rawData
                        }
                    } else {
                        sensorData[key] = null
                    }
                } else if (['Humanoid', 'Hexapod'].includes(connectedDevice)) {
                    if (
                        graphRunInfo[selectedRunGraph].selectedSensors.includes(
                            key
                        )
                    ) {
                        sensorData[key] = humanoidPABytesToSensorData(
                            bytesRecieved,
                            readIndex[key].index
                        )
                    } else {
                        sensorData[key] = null
                    }
                } else {
                    if (
                        graphRunInfo[selectedRunGraph].selectedSensors.includes(
                            key
                        )
                    ) {
                        sensorData[key] = robokiPABytesToSensorData(
                            bytesRecieved.slice(2),
                            readIndex[key].index
                        )
                    } else {
                        sensorData[key] = null
                    }
                }
            })

            sensorData.pv = totalTimeRef.current
            setDatas((prev) => [...prev, sensorData])
        } catch (e) {
            console.log('ERROR', e)
        }
    }

    //generat the line for the line graph
    const generetLine = (lineKey, idx, color) => {
        return (
            <Line
                key={lineKey}
                type="monotone"
                dataKey={lineKey}
                stroke={color}
                activeDot={false}
                dot={(props) => {
                    const { cx, cy, payload, index } = props
                    if (!cx || !cy) {
                        return
                    }
                    const isSelected = isPointSelected(index, lineKey)
                    return (
                        <circle
                            cx={cx}
                            cy={cy}
                            r={isSelected ? 8 : 6}
                            fill={isSelected ? 'red' : color}
                            stroke="#fff"
                            strokeWidth={2}
                            style={{ cursor: 'pointer' }}
                            onClick={() =>
                                handleDotClick(payload, index, lineKey)
                            }
                        />
                    )
                }}
            />
        )
        // ))
    }

    //for each internal sensor generat the graph
    const renderSensors = (sensorData, idx) => {
        let reduxName = graphSidebarData[sensorData].reduxName

        if (!graphPlotStorage.isSelectInternalAccessories?.[reduxName]) {
            return
        }

        if (graphType === 'lineGraph') {
            return generetLine(
                graphSidebarData[sensorData].dataKey,
                idx,
                graphSidebarData[sensorData].bgColour
            )
        } else {
            return (
                <Bar
                    barSize={100}
                    dataKey={graphSidebarData[sensorData].dataKey}
                    fill={graphSidebarData[sensorData].bgColour}
                />
            )
        }
    }

    //for each external sensor generat the graph
    const renderPortData = (portData) => {
        const activePorts = portData.ports.filter((port) => port.isChecked)

        return activePorts.map((port, idx) => (
            <>
                {graphType === 'lineGraph' ? (
                    generetLine(port.portName, idx, port.isColor)
                ) : (
                    <Bar
                        dataKey={`${port.portName}`}
                        fill={`${port.isColor}`}
                        barSize={100}
                    />
                )}
            </>
        ))
    }

    // Function to export full-width graph as PDF
    const exportGraphAsPDF = async () => {
        const chartElement = chartRef.current
        if (!chartElement) return

        // Clone and style to remove overflow
        const clonedChart = chartElement.cloneNode(true)
        document.body.appendChild(clonedChart)

        clonedChart.style.overflow = 'visible'
        clonedChart.style.position = 'absolute'
        clonedChart.style.left = '-9999px'
        clonedChart.style.width = chartElement.scrollWidth + 'px'

        const internalChart = clonedChart.querySelector('div')

        await new Promise((resolve) => setTimeout(resolve, 100))

        const canvas = await html2canvas(internalChart, {
            scale: 2,
            useCORS: true,
            width: internalChart.scrollWidth,
            height: internalChart.scrollHeight,
        })

        const imgData = canvas.toDataURL('image/png')
        const imgWidth = canvas.width
        const imgHeight = canvas.height

        const pdf = new jsPDF({
            orientation: 'landscape',
            unit: 'px',
            format: [imgWidth, imgHeight],
        })

        pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight)
        pdf.save('graph-export.pdf')

        document.body.removeChild(clonedChart)
    }

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key.toLowerCase() === 's') {
                e.preventDefault()
                exportGraphAsPDF()
            }
        }

        window.addEventListener('keydown', handleKeyDown)
        return () => {
            window.removeEventListener('keydown', handleKeyDown)
        }
    }, [])

    useEffect(() => {
        dataQues = datas.slice(datas.length - 10, datas.length)

        // currentData = isPauseBtn == true ? datas : dataQues

        // setCurrentActiveData(() => {
        //     return isPauseBtn ? dataQues : datas
        // })
    }, [datas])

    //read from serial worker
    useEffect(() => {
        const messageHandler = (e) => {
            if (
                ['RobokiPAread', 'PAreadZH', 'PAread', 'PAreadKlaw'].includes(
                    e.data.type
                )
            ) {
                recievedBytes_v(e.data.value)
                // this.recievedBytes(e.data.value)
            } else if (e.data.type == 'PAreadPCv0') {
                // this.recievedBytes_Pcv01(e.data.value, false)
            } else if (
                e.data.type === 'read' &&
                e.data.value === '\r\nEåR\r\n'
            ) {
                stopFuntionRef.current()
            }
        }
        worker.addEventListener('message', messageHandler)
        let plotData = []

        if (selectedRunGraph === 'selectAll') {
            Object.keys(graphRunInfo).map((objKey) => {
                plotData = [...plotData, ...graphRunInfo?.[objKey].plotData]
            })
        } else {
            plotData = graphRunInfo?.[selectedRunGraph]?.plotData || []
        }
        setDatas(plotData)
        return () => {
            worker.removeEventListener('message', messageHandler)
        }
    }, [graphRunInfo, selectedRunGraph, selectedTemperatureScale])

    return (
        <div ref={chartRef} className={style.graphWrapper}>
            <ResponsiveContainer width="100%" height="100%">
                {graphType === 'lineGraph' && (
                    <LineChart data={datas}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <Tooltip />
                        <XAxis dataKey="pv" allowDecimals={true} />
                        <YAxis domain={[0, 1]} />
                        {/* render the enable internal sensors graph */}
                        {Object.keys(graphSidebarData).map(
                            (accessoriesKey, ind) =>
                                renderSensors(accessoriesKey, ind)
                        )}
                        {portsData.map((portData) => (
                            <>{renderPortData(portData)}</>
                        ))}
                        <Brush
                            startIndex={
                                datas.length <= 20 ? 0 : datas.length - 20
                            }
                        />
                        {/* <XAxis dataKey="name" /> */}
                        {/* <YAxis /> */}
                        {/* <Tooltip /> */}
                        {/* <Legend /> */}
                        {/* {lineKeys.map((lineKey, idx) => (
                            <Line
                                key={lineKey}
                                type="monotone"
                                dataKey={lineKey}
                                stroke={idx === 0 ? '#8884d8' : '#82ca9d'}
                                activeDot={false}
                                dot={(props) => {
                                    const { cx, cy, payload, index } = props
                                    const isSelected = isPointSelected(
                                        index,
                                        lineKey
                                    )
                                    return (
                                        <circle
                                            cx={cx}
                                            cy={cy}
                                            r={isSelected ? 8 : 6}
                                            fill={
                                                isSelected
                                                    ? 'red'
                                                    : idx === 0
                                                    ? '#8884d8'
                                                    : '#82ca9d'
                                            }
                                            stroke="#fff"
                                            strokeWidth={2}
                                            style={{ cursor: 'pointer' }}
                                            onClick={() =>
                                                handleDotClick(
                                                    payload,
                                                    index,
                                                    lineKey
                                                )
                                            }
                                        />
                                    )
                                }}
                            />
                        ))} */}
                    </LineChart>
                )}

                {graphType === 'barGraph' && (
                    <BarChart data={[datas[datas.length - 1]]}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <Tooltip />
                        <XAxis allowDecimals={true} dataKey="mic" />
                        <YAxis domain={[0, 1]} />
                        {Object.keys(graphSidebarData).map(
                            (accessoriesKey, ind) =>
                                renderSensors(accessoriesKey, ind)
                        )}

                        {portsData.map((portData) => (
                            <>{renderPortData(portData)}</>
                        ))}
                        {/* <XAxis dataKey="name" />
                        <YAxis />
                        <Tooltip /> */}
                        {/* <CartesianGrid stroke="#ccc" /> */}
                        {/* {lineKeys.map((lineKey, idx) => (
                            <Bar
                                key={lineKey}
                                dataKey={lineKey}
                                fill={idx === 0 ? '#8884d8' : '#82ca9d'}
                            />
                        ))} */}
                    </BarChart>
                )}
            </ResponsiveContainer>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        time: state.graphPlotStorage.time,
        // isSelectInternalAccessories:
        //     state.graphPlotStorage.isSelectInternalAccessories,
        // reduxInternalaccessories: state.graphPlotStorage.internalaccessories,
        graphPlotStorage: state.graphPlotStorage,
        portsData: state.graphPlotStorage.internalaccessories.portsData,
        isSelectAll: state.graphPlotStorage.isSelectAll,
        graphType: state.graphPlotStorage.graphType,
        worker: state.worker,
        slopeInfo: state.graphPlotStorage.slopeInfo,
        graphRunInfo: state.graphPlotStorage.graphRunInfo,
        selectedRunGraph: state.graphPlotStorage.selectedRunGraph,
        selectedTemperatureScale:
            state.graphPlotStorage.selectedTemperatureScale,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setSelectInternalAccessories: (data) => {
            dispatch({ type: 'SET_SELECT_INTERNAL_ACCESSORIES', payload: data })
        },
        setSelectAll: (data) => {
            dispatch({ type: 'SELECT_ALL', payload: data })
        },
        setSlopeInfo: (data) => {
            dispatch({ type: 'EDIT_SLOPE_INFO', payload: data })
        },
        addPlotData: (data) => {
            dispatch({ type: 'ADD_PLOT_DATA', payload: data })
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(GraphGeneration)
